module.exports = __webpack_public_path__ + "img/bg-mision-1-6.aa5c7922.jpg";